import { useFliptBoolean } from "@flipt-io/flipt-client-react";
import useUser from "~/contexts/user";
import { FLIPT_ROUTE_KEYS } from "~/router/constants";

export const useAtlasRedesignFeature = (): boolean => {
  const user = useUser();
  return useFliptBoolean(FLIPT_ROUTE_KEYS.ATLAS_REDESIGN, false, user?.email);
};
